import React, { memo } from 'react';
import InboxMessageItem from './InboxMessageItem';
import { useInbox } from '../hooks';
import { Box } from '@betty/moonlight';
import { FlatList } from 'react-native';

function InboxMessageList() {
  const { inbox } = useInbox();

  return (
    <FlatList
      removeClippedSubviews={false}
      ItemSeparatorComponent={() => (
        <Box
          marginHorizontal="space-600"
          backgroundColor="washedBackground"
          height="space-025"
        />
      )}
      viewabilityConfig={{ itemVisiblePercentThreshold: 100 }}
      data={inbox}
      renderItem={({ item }) => <InboxMessageItem {...item} />}
      keyExtractor={(item) => `${item.id}`}
      contentContainerStyle={{ paddingBottom: 30 }}
    />
  );
}

export default memo(InboxMessageList);
